const dark = {
	50: '#e2ffbc',
	100: '#daf6bb',
	200: '#b5ca94',
	300: '#89a46d',
	400: '#79864c',
	500: '#576b2f',
	600: '#536328',
	700: '#4c5426',
	800: '#4c5622',
	900: '#454610',
	A100: '#c7ff70',
	A200: '#bcff3c',
	A400: '#aeff14',
	A700: '#aeff14'
};

export default dark;